module.exports = __webpack_public_path__ + "static/img/Sent.c24eaecd.png";